module.exports = __webpack_public_path__ + "static/media/call.57919dfc.svg";